











import { computed, defineComponent } from "@vue/composition-api";
import useHideMainMenu from "@/hooks/useHideMainMenu";
import config from "@/config";
import BasePage from "@/components/BasePage";
import SignUpComponent from "@/components/SignUpComponent";

export default defineComponent({
  name: "PageSignUp",
  components: { BasePage, SignUpComponent },
  setup(_, { root }) {
    useHideMainMenu();
    const isSoloCreator = computed(() => !!config.soloCreatorId);
    const handleSwitchTab = (value: string) => {
      root.$router.replace({
        query: value === "creator" ? { redirectPath: "/more/payeeInfo" } : {},
      });
    };
    return { isSoloCreator, handleSwitchTab };
  },
});
